if ($('#fixedCTA').length) {
    $('#vslCTA').each(function() {
        const currentEl = $('#fixedCTA');
        let isShown;

        window.doWhenInViewport($(this)[0], function(entries, observer) {
            if (!entries[0].isIntersecting && typeof isShown !== 'undefined') {
                $(currentEl).addClass('shown');
                isShown = true;
            } else {
                $(currentEl).removeClass('shown');
                isShown = false;
            }
        });
    });

    // calculate fixed cta height and assign it as MB to footer
    const fixedCtaHeight = document.getElementById('fixedCTA').offsetHeight;
    document.querySelector('.footer').style.setProperty('--footerMB', fixedCtaHeight + 'px');
}